import { render, staticRenderFns } from "./detail-lead.vue?vue&type=template&id=385105af"
import script from "./detail-lead.vue?vue&type=script&lang=js"
export * from "./detail-lead.vue?vue&type=script&lang=js"
import style0 from "./css/font-awesome/css/all.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports